export async function sha256Hex(bytes, subtle = crypto.subtle) {
    const digest = await subtle.digest("SHA-256", new Uint8Array(bytes).buffer);
    return [...new Uint8Array(digest)].map((value) => value.toString(16).padStart(2, "0")).join("");
}
//# sourceMappingURL=sha256.js.map